/** Non-empty array. */
export type NonEmptyArray<T> = readonly [T, ...T[]];

/**
 * Type guard for non empty array.
 * @param array Source array.
 */
export function isNonEmpty<T>(array: readonly T[]): array is NonEmptyArray<T> {
  return array.length > 0;
}
